import React from 'react';
import OnboardingTour from '../../shared/onboarding/OnboardingTour';
import { ProjectPermission } from 'nekst-api';

export default function ProjectDetailsPageTour() {
  return (
    <OnboardingTour
      tourId="PropertyDetailsPage"
      steps={[
        {
          selector: '[data-testid="edit-details"]',
          resizeObservables: ['[data-testid="edit-details"]'],
          content: 'See a snapshot of all transaction details. Information from here will display on the “Transactions” page.',
        },
        {
          selector: '[data-testid="update-project-form"]',
          content: 'Change the Transaction Type, Status, apply a new Workflow or update the Start & End Date to adjust your tasks after they are applied.',
          permission: ProjectPermission.UPDATE,
        },
        {
          selector: '[data-testid="project-start-end-date-fields"]',
          content: 'Change the Start and End Dates to move tasks around based on changes in closing date or contract date',
          permission: ProjectPermission.UPDATE,
        },
        {
          selector: '[data-testid="edit-launch-button"]',
          content: 'Click to access the 5-Step Process when launching a new Transaction.',
          permission: ProjectPermission.UPDATE,
        },
        {
          selector: '[data-testid="project-notes"]',
          content: 'Store general notes about a transaction and Tag team members',
        },
      ]}
    />
  );
}
